export default {"src":"/_next/static/media/go-arrow.31a1334d.svg","height":24,"width":24};